// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"18d5f9d8","338":"d05846de","378":"7d512e6e","380":"5430a05e","401":"72e12411","467":"0244c464","513":"eb242227","528":"358dc92f","544":"bb58a2fd","635":"96120dde","642":"b2ef245b","653":"6ee7c872","735":"3020e190","739":"8283d380","945":"35493779"}[chunkId] + ".chunk.js";
};